import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { httpService } from "utils";

import { useReactQuery } from "components/RemoteData";

import { ILoggedUser } from "../application/types/ILoggedUser";
import { useGetAuthorizationStore } from "../../authentication/infrastructure/useGetAuthorizationStore";
import { ILoggedUserDto } from "../application/types/ILoggedUserDto";
import { DateObject } from "../../../utils/DateObject";

export const useGetUser = () => {
  const { tokenSecurity, userId } = useGetAuthorizationStore((state) => ({
    tokenSecurity: state.tokenSecurity,
    userId: state.userId,
  }));
  const { friendlyUrl } = useGetFriendlyUrl();

  return useReactQuery(getUserKey(userId, tokenSecurity), () =>
    getUser(friendlyUrl, tokenSecurity, userId)
  );
};

export const getUser = (
  friendlyUrl: string,
  tokenSecurity: string | null,
  userId: string | null
): Promise<ILoggedUser | null> => {
  if (!userId) {
    return new Promise<ILoggedUser | null>((resolve) => resolve(null));
  }

  return httpService()
    .get<ILoggedUserDto>(`/e-reservation/user/${userId}/info`)
    .then((res) => {
      return {
        ...res,
        loginDate: DateObject(res.loginDate),
      };
    });
};

export const getUserKey = (
  userId: string | null,
  tokenSecurity: string | null
) => {
  return ["user-information", userId, tokenSecurity];
};
